import './style.scss';

import { UserTypeEnum } from '@enums/user-type.enum';
import { IUser } from '@interfaces/user';
import { NUserPayment } from '@interfaces/user-payment';
import { useGetIdentity, useOne, useTranslate } from '@refinedev/core';
import { Button, Col, Image, Row } from 'antd';
import { DataProviderNameEnum } from 'dataProvider';
import { createContext, FC, ReactNode, useContext } from 'react';
import { Link } from 'react-router-dom';

import { useQuery } from '../../../onboarding/step-one';

export const PayoutContext = createContext<string | string>(
    'useContext should be used inside ContextProvider',
);

export const PayoutContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const dataProviderName = DataProviderNameEnum.INTERNAL_CRM;
    const translate = useTranslate();
    const { data: userIdentity } = useGetIdentity<IUser.IUserIdentity>();
    const query = useQuery();
    const token = query.get('token');
    const getUserPayment = userIdentity?.userType === UserTypeEnum.RESELLER && !token;

    const { data: userPayment, isLoading } = useOne<NUserPayment.IUserPaymentDto>({
        resource: 'v1/user-payments',
        id: '',
        queryOptions: {
            enabled: getUserPayment,
        },
        dataProviderName,
    });

    return (
        <>
            {getUserPayment && !isLoading && !userPayment?.data ? (
                <>
                    <div className="payout-notification error w-full">
                        <span className="text-base notification-text">
                            {translate('crm_internal.account_not_existed')}
                        </span>
                    </div>
                    <Row className="tenant-setting-header-row">
                        <Col
                            className="tenant-setting-header-col w-full h-full items-center justify-between"
                            span={24}
                        >
                            <h2 className="mb-2">
                                {translate('settings.update_payout_setting', 'Payout setting')}
                            </h2>
                        </Col>
                        <Button icon={false} className="create-issue-button" type="primary">
                            <Link to={`/sale/payout`} className="table-tbody-text">
                                <Image preview={false} src={'/images/icons/white-pen.svg'} />
                                <span className="ml-2">
                                    {translate('crm_internal.update_payout_setting')}
                                </span>
                            </Link>
                        </Button>
                    </Row>
                </>
            ) : (
                <>{children}</>
            )}
        </>
    );
};

export const usePayoutContext = () => {
    const context = useContext(PayoutContext);
    if (typeof context === 'string') {
        throw new Error(context);
    }
    return context;
};
